import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "36",
  height: "36",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "18",
      cy: "18",
      r: "18",
      fill: "#007AFF"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.584 9.25L20.084 11.75L17.584 14.25M18.4173 21.75L15.9173 24.25L18.4173 26.75M16.334 24.25H19.6673C23.1191 24.25 25.9173 21.4518 25.9173 18C25.9173 15.9555 24.9356 14.1403 23.4179 13M19.6673 11.75H16.334C12.8822 11.75 10.084 14.5482 10.084 18C10.084 20.0445 11.0657 21.8597 12.5834 23",
      stroke: "white",
      "stroke-linecap": "square"
    }, null, -1)
  ])))
}
export default { render: render }